export const CancelPanelKey = {
  CancelReasonPanel: "cancel-request-reason-panel",
  CancelConfirmPanel: "cancel-request-confirm-panel",
  CancelSuccessPanel: "cancel-request-success-panel",
  CancelErrorPanel: "cancel-request-error-panel",
} as const;

export type CancelPanelKeyType = (typeof CancelPanelKey)[keyof typeof CancelPanelKey];

export const CancelReasonKey = {
  SubmitError: "cancel.reason/submitted-in-error",
  FilledByAltSrc: "cancel.reason/filled-by-another-source",
  SubNotNeeded: "cancel.reason/sub-no-longer-needed",
  Dissatisfied: "cancel.reason/dissatisfied-with-sub",
  Other: "cancel.reason/other",
  EditRequest: "cancel.reason/unable-to-edit",
  NotFilledInTime: "cancel.reason/not-filled-in-time",
  PreferDifferentSub: "cancel.reason/prefer-different-sub",
  UnhappyWithWaitlist: "cancel.reason/unhappy-with-waitlist",
} as const;

export type CancelReasonKeyType = (typeof CancelReasonKey)[keyof typeof CancelReasonKey];
